import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DemoTypeConstants } from "model/Model";
import { Selectable } from "Utilities";

const measuresWithIsRankedSlice = createSlice( {
  name: "measures",
  initialState: [] as Array<Selectable<{ value: DemoTypeConstants; isRanked: boolean; }>>,
  reducers: {
    ChangeDemoTypePosition( state, action: PayloadAction<{ srcValue: DemoTypeConstants; dstValue: DemoTypeConstants; }> ) {
      const { srcValue, dstValue } = action.payload;
      const updated = [ ...state ];
      const srcIndex = updated.findIndex( m => m.value === srcValue );
      const dstIndex = updated.findIndex( m => m.value === dstValue );

      updated.splice( dstIndex, 0, updated.splice( srcIndex, 1 )[ 0 ] );
      return updated;
    },

    ChangeDemoTypeSelected( state, action: PayloadAction<{ value: DemoTypeConstants; isSelected: boolean; }> ) {
      const { value, isSelected } = action.payload;
      return state.map( m => m.value === value ? { ...m, isSelected } : m );
    },

    ChangeDemoTypeRanked( state, action: PayloadAction<{ value: DemoTypeConstants; isRanked: boolean; }> ) {
      const { value, isRanked } = action.payload;
      return state.map( m => m.value === value ? { ...m, isRanked } : m );
    }
  }
} );

export const { ChangeDemoTypePosition, ChangeDemoTypeRanked, ChangeDemoTypeSelected } = measuresWithIsRankedSlice.actions;

export default measuresWithIsRankedSlice.reducer;